/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponseData;

  constructor(
    err:
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse";
  }
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse(
        v,
      );
    });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse
  > = z.instanceof(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateErrorResponse$Outbound;
}
